'use client'

import Link from 'next/link'

import { Icon, IconComponent } from '@graftcode/design-system'

import { documentationNavUrlPathForSection } from '@/lib/github/documentationSlug'
import type { TutorialSection } from '@/lib/github/types'
import { useDocumentationLanguageContext } from '@/shared/components/DocumentationLayoutShell/context/documentationLanguageContext'
import { buildDocumentationHref } from '@/shared/docs-shared.utils'
import { DOCUMENTATION_NAV_LINKS_TEST_IDS } from '@/shared/docs-test-ids.const'

import styles from '@/shared/components/DocumentationArticle/DocumentationArticle.module.scss'

type NavSection = Pick<TutorialSection, 'title' | 'path' | 'languages' | 'defaultLanguage'>

interface DocumentationNavLinksProps {
  prevSection: NavSection | null
  nextSection: NavSection | null
}

export function DocumentationNavLinks({ prevSection, nextSection }: DocumentationNavLinksProps) {
  const { selectedLanguage } = useDocumentationLanguageContext()
  const lang = selectedLanguage ?? undefined

  const prevHref = prevSection ? buildDocumentationHref(documentationNavUrlPathForSection(prevSection, lang)) : null
  const nextHref = nextSection ? buildDocumentationHref(documentationNavUrlPathForSection(nextSection, lang)) : null

  return (
    <div data-testid={DOCUMENTATION_NAV_LINKS_TEST_IDS.root} className={styles.navigation}>
      {prevHref ? (
        <Link href={prevHref} className={styles.navCard}>
          <span className={styles.navLabel}>Previous</span>
          <span className={styles.navTitleRow}>
            <IconComponent icon={Icon.ChevronLeftRegular} size={20} />
            <span className={styles.navSectionTitle}>{prevSection!.title}</span>
          </span>
        </Link>
      ) : (
        <div className={styles.navSpacer} />
      )}

      {nextHref ? (
        <Link href={nextHref} className={`${styles.navCard} ${styles.navCardNext}`}>
          <span className={styles.navLabel}>Next</span>
          <span className={styles.navTitleRow}>
            <span className={styles.navSectionTitle}>{nextSection!.title}</span>
            <IconComponent icon={Icon.ChevronRightRegular} size={20} />
          </span>
        </Link>
      ) : (
        <div className={styles.navSpacer} />
      )}
    </div>
  )
}
